import { Link } from 'react-router-dom';
import { Web3Button } from "@web3modal/react";

import biofiLogo from '../images/biofi-logo.svg';

export default function Navbar() {

  return (

    <nav>
      <div className="bf-nav1">
        <div className="bf-navlogo">
          <Link to="/" className="bf-nav-logo bf-nav-brand">
            <img className="bf-navlogo" src={biofiLogo} alt="BioFi" />
          </Link>
        </div>

        <Web3Button icon="show" label="Connect Wallet" balance="hide" />
      </div>
    </nav>
  );
}